import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useIntl } from '@/intl'
import styles from './ParticipantEditShared.module.css'

export function ParticipantEditNoChangesBanner() {
  const { formatMessage } = useIntl()

  return (
    <Banner hasIcon color="informative" size="M" className={styles.stickyBanner}>
      <Banner.TextsWrapper>
        <Banner.Text>
          {formatMessage({ id: 'common_no_changes_title' })}
        </Banner.Text>
        <Banner.SupportingText>
          {formatMessage({ id: 'common_no_changes_message' })}
        </Banner.SupportingText>
      </Banner.TextsWrapper>
    </Banner>
  )
}
